// Page Read
export const PAGE_DATA_PENDING = 'PAGE_DATA_PENDING';
export const PAGE_DATA_FULFILLED = 'PAGE_DATA_FULFILLED';
export const PAGE_DATA_REJECTED = 'PAGE_DATA_REJECTED';
// Page Write
export const PAGE_SAVE_DATA_PENDING = 'PAGE_SAVE_DATA_PENDING';
export const PAGE_SAVE_DATA_FULFILLED = 'PAGE_SAVE_DATA_FULFILLED';
export const PAGE_SAVE_DATA_REJECTED = 'PAGE_SAVE_DATA_REJECTED';
// Add Page
export const PAGE_ADD_PAGE = 'PAGE_ADD_PAGE';
// Page Updated
export const PAGE_LAYOUT_CONFIGURATION = 'PAGE_LAYOUT_CONFIGURATION';
// Component Edit
export const PAGE_COMPONENT_EDIT = 'PAGE_COMPONENT_EDIT';
// Component Updated
export const PAGE_COMPONENT_CONFIGURATION = 'PAGE_COMPONENT_CONFIGURATION';
// Component Wrapper Edit
export const PAGE_COMPONENT_WRAPPER_EDIT = 'PAGE_COMPONENT_WRAPPER_EDIT';
// Selected Tabs
export const PAGE_SELECTED_TABS = 'PAGE_SELECTED_TABS';